import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=1363c59c&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=1363c59c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1363c59c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1363c59c')) {
      api.createRecord('1363c59c', component.options)
    } else {
      api.reload('1363c59c', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=1363c59c&scoped=true&", function () {
      api.rerender('1363c59c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-243RxGj6pTbjm/JS/comp/DateRangeExt.vue"
export default component.exports